import Flex from 'components/Flex'
import Page from 'modules/Page/Container/index'
import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { authenticated } from 'routes/config/user'
import styled from 'styled-components'
import { PermittedNavRoutes } from '../../utils/permissionsValidation'
const { AUTH_URL } = process.env
import { useSelector } from 'react-redux'
const PageFlex = styled(Flex)`
  overflow: hidden;
`
const AuthPage = ({ isAuthenticated, permissions }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isIdle, setIsIdle] = useState(false)
   const instituteDetails = useSelector(
      state => state?.auth?.instituteDetails
    )
    const accessLevel = instituteDetails?.instituteSubscription?.accessLevel
console.log(accessLevel,'accessLevel')
  useEffect(() => {
    let idleTimer

    const resetTimer = () => {
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => setIsIdle(true), 900000)
    }

    const onActivity = () => {
      setIsIdle(false)
      resetTimer()
    }

    resetTimer()

    window.addEventListener('mousemove', onActivity)
    window.addEventListener('keydown', onActivity)
    window.addEventListener('scroll', onActivity)

    return () => {
      clearTimeout(idleTimer)
      window.removeEventListener('mousemove', onActivity)
      window.removeEventListener('keydown', onActivity)
      window.removeEventListener('scroll', onActivity)
    }
  }, [])

  useEffect(() => {
    if (isIdle) {
      window.location.href = AUTH_URL
      window.location.replace(AUTH_URL)
    }
  }, [isIdle])
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/signin')
    } else if (location?.pathname === '/') {
      if (accessLevel === 1 || accessLevel === 3) {
        navigate('/tpoDashboard')
      } else {
        navigate('/students')
      }
    }
  }, [isAuthenticated,accessLevel])

  const permittedRoutes = PermittedNavRoutes(permissions, authenticated)
  return (
    <PageFlex>
      {isAuthenticated && (
        <Page>
          <Routes>
            {permittedRoutes?.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                ></Route>
              )
            })}
          </Routes>
        </Page>
      )}
    </PageFlex>
  )
}

export default AuthPage
